export const HELP_AND_SUPPORT_DATA = {
  en: {
    title: "AskSalah Help and Support",
    initialMessage: "Hello, {name} What do you need help with?",
    contactSupportMessage:
      <>For personalized assistance, please click the Telegram link to connect with our support team <a href="https://t.me/SmartsWay125" target="_blank" rel="noopener noreferrer">https://t.me/SmartsWay125</a></>,
    ticketCreatedMessage:
      <>For personalized assistance, please click the Telegram link to connect with our support team <a href="https://t.me/SmartsWay125" target="_blank" rel="noopener noreferrer">https://t.me/SmartsWay125</a></>,
    inputPlaceholder: "Type your message...",
    sendButton: "Send",
    responseTime: "Typical response time : 1hr",
    predefinedQuestions: [
      {
        id: "subscription_access",
        text: "Subscription & Access",
        answer:
          "AskSalah is an add-on service to the SAL125 program. You must have an active SAL125 subscription before you can activate AskSalah. Without SAL125, you will not be able to create or use sessions inside AskSalah.",
        followUpQuestions: [
          { id: "need_sal125", text: "Do I need SAL125 to use AskSalah?" },
          {
            id: "buy_without_sal125",
            text: "Can I buy AskSalah without SAL125?",
          },
          { id: "bundle_options", text: "What are the bundle options?" },
        ],
      },
      {
        id: "pricing",
        text: "Pricing",
        answer:
          "AskSalah offers Basic ($11.99/month or $120/year) and Premium ($24.99/month or $250/year) subscriptions. SAL125 costs $245 for 1 year or $375 for 2 years. Bundle packages provide 10% discount when purchased together.",
        followUpQuestions: [
          { id: "basic_cost", text: "How much does AskSalah Basic cost?" },
          { id: "premium_cost", text: "How much does AskSalah Premium cost?" },
          { id: "sal125_cost", text: "How much does SAL125 cost?" },
          { id: "bundle_pricing", text: "How does bundle pricing work?" },
        ],
      },
      {
        id: "usage_rules",
        text: "Usage Rules",
        answer:
          "Every AskSalah subscription comes with 10 sessions per month that renew monthly. Each session can last up to 45 minutes. You can pause sessions but must resume within 24 hours.",
        followUpQuestions: [
          { id: "sessions_per_month", text: "How many sessions can I use?" },
          {
            id: "session_duration",
            text: "What is the maximum session duration?",
          },
          { id: "pause_session", text: "Can I pause a session?" },
        ],
      },
      {
        id: "how_to_use",
        text: "How to Use Sessions",
        answer:
          "Go to your dashboard, select a category, click More Info, then Start Session. After completing a session, you can download a PDF summary and review details in the History section.",
        followUpQuestions: [
          { id: "start_session", text: "How do I start a session?" },
          { id: "session_summary", text: "Can I get a session summary?" },
          { id: "find_past_sessions", text: "Where can I find past sessions?" },
          {
            id: "review_rate_session",
            text: "Can I review or rate a session?",
          },
        ],
      },
      {
        id: "plan_differences",
        text: "Plan Differences",
        answer:
          "Basic gives you 10 text-based chat sessions per month. Premium gives you 10 voice-based sessions with Dr. Salah's AI voice, making the experience more immersive and personal.",
        followUpQuestions: [
          {
            id: "basic_vs_premium",
            text: "What's the difference between Basic and Premium?",
          },
        ],
      },
      {
        id: "technical_general",
        text: "Technical & General",
        answer:
          "AskSalah supports both Arabic and English, works on any device with a browser, and uses end-to-end encryption to protect your data. It complies with GDPR and CCPA regulations.",
        followUpQuestions: [
          {
            id: "languages_supported",
            text: "Is AskSalah available in Arabic and English?",
          },
          {
            id: "device_compatibility",
            text: "On which devices can I use AskSalah?",
          },
          { id: "data_security", text: "Is my data secure?" },
        ],
      },
    ],
  },
  ar: {
    title: "دعم ومساعدة AskSalah",
    initialMessage: "مرحبًا، {name} كيف يمكننا مساعدتك؟",
    contactSupportMessage:
      <>للحصول على مساعدة شخصية، يرجى النقر على رابط التليجرام للتواصل مع فريق الدعم  <a href="https://t.me/SmartsWay125" target="_blank" rel="noopener noreferrer">https://t.me/SmartsWay125</a></>,
    ticketCreatedMessage:
      <>للحصول على مساعدة شخصية، يرجى النقر على رابط التليجرام للتواصل مع فريق الدعم  <a href="https://t.me/SmartsWay125" target="_blank" rel="noopener noreferrer">https://t.me/SmartsWay125</a></>,
    inputPlaceholder: "اكتب رسالتك...",
    sendButton: "إرسال",
    responseTime: "وقت الاستجابة المعتاد: ساعة واحدة",
    predefinedQuestions: [
      {
        id: "subscription_access",
        text: "الاشتراك في البرنامج",
        answer:
          "AskSalah هو خدمة إضافية لبرنامج SAL125. يجب أن يكون لديك اشتراك فعال في SAL125 قبل تفعيل AskSalah. بدون SAL125، لن تتمكن من إنشاء أو استخدام الجلسات داخل AskSalah.",
        followUpQuestions: [
          {
            id: "need_sal125",
            text: "هل أحتاج إلى اشتراك في SAL125 لاستخدام AskSalah؟",
          },
          {
            id: "buy_without_sal125",
            text: "هل يمكنني شراء AskSalah بدون SAL125؟",
          },
          {
            id: "bundle_options",
            text: "ما هي خيارات الجمع بين اشتراك SAL125 وAskSalah؟",
          },
        ],
      },
      {
        id: "pricing",
        text: "مبالغ الاشتراك",
        answer:
          "الاشتراك الأساسي في AskSalah يكلف 11.99 دولار شهريًا أو 120 دولار سنويًا. الاشتراك المميز يكلف 24.99 دولار شهريًا أو 250 دولار سنويًا. SAL125 يكلف 245 دولار لمدة سنة واحدة أو 375 دولار لمدة سنتين. الحزم المدمجة توفر خصم 10%.",
        followUpQuestions: [
          { id: "basic_cost", text: "كم يكلف اشتراك AskSalah الأساسي؟" },
          { id: "premium_cost", text: "كم يكلف اشتراك AskSalah المميز؟" },
          { id: "sal125_cost", text: "كم يكلف اشتراك SAL125؟" },
          {
            id: "bundle_pricing",
            text: "كيف يعمل تسعير الجمع بين اشتراك SAL125 وAskSalah؟",
          },
        ],
      },
      {
        id: "usage_rules",
        text: "قواعد الاستخدام",
        answer:
          "كل اشتراك في AskSalah يتضمن 10 جلسات شهريًا. يتم تجديد الجلسات كل شهر تلقائيًا. كل جلسة يمكن أن تستمر حتى 45 دقيقة. يمكنك إيقاف الجلسة مؤقتًا ولكن يجب استئنافها خلال 24 ساعة.",
        followUpQuestions: [
          {
            id: "sessions_per_month",
            text: "كم عدد الجلسات التي يمكنني استخدامها في AskSalah؟",
          },
          { id: "session_duration", text: "ما هي المدة القصوى للجلسة؟" },
          { id: "pause_session", text: "هل يمكنني إيقاف الجلسة مؤقتًا؟" },
        ],
      },
      {
        id: "how_to_use",
        text: "كيفية استخدام الجلسة",
        answer:
          "اذهب إلى لوحة التحكم الخاصة بك، اختر الجلسة التي تريد، اضغط على مزيد من المعلومات، ثم اختر بدء الجلسة. بعد الانتهاء من الجلسة، يمكنك تحميل ملخص بصيغة PDF ومراجعة التفاصيل في قسم السجل.",
        followUpQuestions: [
          { id: "start_session", text: "كيف أبدأ جلسة في AskSalah؟" },
          { id: "session_summary", text: "هل يمكنني الحصول على ملخص لجلساتي؟" },
          { id: "find_past_sessions", text: "أين أجد جلساتي السابقة؟" },
          {
            id: "review_rate_session",
            text: "هل يمكنني تقييم أو مراجعة الجلسة؟",
          },
        ],
      },
      {
        id: "plan_differences",
        text: "الاختلاف بين الاشتراكات",
        answer:
          "الاشتراك الأساسي: يمنحك 10 جلسات شهرية عبر الدردشة فقط. الاشتراك المميز: يمنحك 10 جلسات شهرية عبر الصوت باستخدام صوت الدكتور صلاح، مما يجعل التجربة أكثر تفاعلاً وشخصية.",
        followUpQuestions: [
          {
            id: "basic_vs_premium",
            text: "ما الفرق بين الاشتراك الأساسي والاشتراك المميز؟",
          },
        ],
      },
      {
        id: "technical_general",
        text: "أسئلة تقنية وعامة",
        answer:
          "AskSalah يدعم اللغة العربية واللغة الإنجليزية. يمكنك استخدامه على أي جهاز يحتوي على متصفح إنترنت. يستخدم AskSalah تشفير شامل لحماية بياناتك ويتوافق مع اللوائح الدولية مثل GDPR وCCPA.",
        followUpQuestions: [
          {
            id: "languages_supported",
            text: "هل يتوفر AskSalah باللغتين العربية والإنجليزية؟",
          },
          {
            id: "device_compatibility",
            text: "على أي أجهزة يمكنني استخدام AskSalah؟",
          },
          { id: "data_security", text: "هل بياناتي آمنة؟" },
        ],
      },
    ],
  },
};

// Detailed answers for follow-up questions
export const DETAILED_ANSWERS = {
  en: {
    // Subscription & Access
    need_sal125:
      "Yes. AskSalah is an add-on service to the SAL125 program. You must have an active SAL125 subscription before you can activate AskSalah. Without SAL125, you will not be able to create or use sessions inside AskSalah.",
    buy_without_sal125:
      "No. AskSalah is only available to members who already have an active subscription to SAL125. However, you can purchase both SAL125 and AskSalah together as a bundle package.",
    bundle_options:
      "Bundle packages allow you to combine SAL125 with AskSalah Basic or Premium at a discounted price. You can choose a 1-year or 2-year bundle, and the total cost will include both subscriptions with a 10% discount compared to buying them separately.",

    // Pricing
    basic_cost:
      "The Basic subscription for AskSalah includes chat-only sessions. The cost is $11.99 per month or $120 per year. The yearly plan gives you two months free compared to paying monthly.",
    premium_cost:
      "The Premium subscription includes full voice sessions with Dr. Salah's AI-powered voice, in addition to chat. The cost is $24.99 per month or $250 per year. Like the Basic plan, the yearly option is more economical than paying month-to-month.",
    sal125_cost:
      "SAL125 has two subscription durations: 1 year for $245 and 2 years for $375. SAL125 does not offer monthly plans.",
    bundle_pricing:
      "When you purchase SAL125 and AskSalah together in a bundle (either Basic or Premium), you receive a 10% discount on the combined total. For example, if you buy SAL125 (1 year = $245) with AskSalah Premium (1 year = $250), the bundle cost will be $445.50 instead of $495.",

    // Usage Rules
    sessions_per_month:
      "Every AskSalah subscription comes with 10 sessions per month. These sessions renew monthly, so you start each month with 10 available sessions. If you use them all before the month ends, you will need to wait until the next month for your balance to refresh.",
    session_duration:
      "Each AskSalah session can last up to 45 minutes. This allows for a deep and structured conversation, while still keeping the sessions focused and manageable.",
    pause_session:
      "Yes. You can pause a session if you need to stop temporarily. However, you must resume it within 24 hours, otherwise the session will expire and be counted as used. This ensures fairness and keeps session usage balanced for all subscribers.",

    // How to Use
    start_session:
      "Go to your user dashboard, select the category you want, click on More Info, then press Start Session.",
    session_summary:
      "Yes. After completing a session, you can download a PDF summary. You can also review details later in the History section for each session.",
    find_past_sessions:
      "All past sessions are stored in the History section. You can open any session to review details, track your progress, or re-read your insights.",
    review_rate_session:
      "Yes, and we encourage it. After each session, you can leave a review or rating. This helps you reflect on your experience and improves the AI's future guidance.",

    // Plan Differences
    basic_vs_premium:
      "The difference is in the mode of interaction: Basic gives you access to 10 text-based chat sessions per month with AskSalah. Premium gives you 10 voice-based sessions per month where you can interact with Dr. Salah's cloned voice, making the experience more immersive and personal. Both plans allow the same number of sessions and the same session length (45 minutes), but Premium adds the extra benefit of voice interaction.",

    // Technical & General
    languages_supported:
      "Yes. AskSalah supports both Arabic and English. You can choose the language you are most comfortable with when interacting with the application.",
    device_compatibility:
      "AskSalah is a web-based platform, so you can use it on any device that has an internet browser. This includes computers, tablets, and smartphones. The platform is fully responsive and works with Chrome, Safari, Firefox, and Edge.",
    data_security:
      "Yes. Your privacy and security are a top priority. AskSalah uses end-to-end encryption to protect your data during sessions and complies with international data protection regulations such as GDPR and CCPA. Your conversations are not shared with third parties, and all data is stored securely.",
  },
  ar: {
    need_sal125:
      "نعم. AskSalah هي خدمة إضافية لبرنامج SAL125. يجب أن يكون لديك اشتراك فعال في SAL125 قبل تفعيل AskSalah. بدون SAL125، لن تتمكن من إنشاء أو استخدام الجلسات داخل AskSalah.",
    buy_without_sal125:
      "لا. AskSalah متاح فقط للأعضاء الذين يمتلكون اشتراكًا فعال في SAL125. ومع ذلك، يمكنك شراء SAL125 وAskSalah معا كحزمة مدمجة.",
    bundle_options:
      "تتيح لك الحزم المدمجة تجميع SAL125 مع AskSalah الأساسي أو المميز بسعر مخفض. يمكنك اختيار حزمة 1 سنة أو 2 سنة، وسيتم تضمين كلا الاشتراكين مع خصم 10% مقارنة بشرائهما بشكل منفصل.",
    basic_cost:
      "الاشتراك الأساسي في AskSalah يتضمن جلسات دردشة فقط. التكلفة هي 11.99 دولار شهريًا أو 120 دولار سنويًا. الخطة السنوية تمنحك شهرين مجانيين مقارنة بالدفع شهريًا.",
    premium_cost:
      "الاشتراك المميز يتضمن جلسات صوتية كاملة باستخدام صوت الدكتور صلاح، بالإضافة إلى الدردشة. التكلفة هي 24.99 دولار شهريًا أو 250 دولار سنويًا. مثل الخطة الأساسية، الخطة السنوية هي الخيار الاقتصادي مقارنة بالدفع شهريًا.",
    sal125_cost:
      "SAL125 لديها فترتين للاشتراك: 1 سنة بسعر 245 دولار و2 سنة بسعر 375 دولار. SAL125 لا تقدم خطط شهرية.",
    bundle_pricing:
      "عند شراء SAL125 وAskSalah معا كحزمة (أساسي أو مميز)، يتم إعطاءك خصم 10% على الإجمالي المجمع. على سبيل المثال، إذا كنت تشتري SAL125 (1 سنة = 245 دولار) مع AskSalah المميز (1 سنة = 250 دولار)، فسيكون سعر الحزمة 445.50 دولار بدلا من 495 دولار.",
    sessions_per_month:
      "كل اشتراك في AskSalah يتضمن 10 جلسات شهريًا. يتم تجديد الجلسات كل شهر تلقائيًا. كل جلسة يمكن أن تستمر حتى 45 دقيقة. يمكنك إيقاف الجلسة مؤقتًا ولكن يجب استئنافها خلال 24 ساعة.",
    session_duration:
      "كل جلسة في AskSalah يمكن أن تستمر حتى 45 دقيقة. يتيح هذا التحديد للدردشة المنظمة والمبنية، ولكن يبقى الجلسة مركزة وقابلة للتحكم.",
    pause_session:
      "نعم. يمكنك إيقاف الجلسة مؤقتًا إذا كنت بحاجة إلى التوقف مؤقتًا. ومع ذلك، يجب استئنافها خلال 24 ساعة، وإلا سينتهي الجلسة ويعتبر مستخدمًا. هذا يضمن العدالة ويحافظ على استخدام الجلسة متساويًا لجميع الأعضاء.",
    start_session:
      "اذهب إلى لوحة التحكم الخاصة بك، اختر الجلسة التي تريد، اضغط على مزيد من المعلومات، ثم اختر بدء الجلسة.",
    session_summary:
      "نعم. بعد الانتهاء من الجلسة، يمكنك تحميل ملخص بصيغة PDF. يمكنك أيضًا مراجعة التفاصيل لاحقًا في قسم السجل لكل جلسة.",
    find_past_sessions:
      "جميع الجلسات السابقة مخزنة في قسم السجل. يمكنك فتح أي جلسة لمراجعة التفاصيل، تتبع التقدم، أو إعادة قراءة التفاصيل.",
    review_rate_session:
      "نعم، ونحن نشجع ذلك. بعد كل جلسة، يمكنك ترك مراجعة أو تقييم. يساعد هذا في التعبير عن تجربتك ويحسن توصية   الذكاء الاصطناعي للمستقبل.",
    basic_vs_premium:
      "الفرق هو في وسيلة التفاعل: الأساسي يمنحك وصول إلى 10 جلسات شهرية  في AskSalah عبر دردشة فقط . المميز يمنحك 10 جلسات شهرية عبر الصوت باستخدام صوت الدكتور صلاح، مما يجعل التجربة أكثر تفاعلاً وشخصية. يسمح كلا الخطط بنفس عدد الجلسات ونفس المدة الجلسة (45 دقيقة)، ولكن المميز يضيف الفائدة الإضافية للتفاعل عبر الصوت.",
    languages_supported:
      "نعم. AskSalah يدعم اللغتين العربية والإنجليزية. يمكنك اختيار اللغة التي تجدها أكثر ملاءمة لديك عند التفاعل مع التطبيق.",
    device_compatibility:
      "AskSalah هي منصة عبر الإنترنت، لذلك يمكنك استخدامها على أي جهاز يحتوي على متصفح إنترنت. هذا يشمل الكمبيوترات والأجهزة اللوحية والهواتف الذكية. المنصة متطورة وتعمل مع Chrome وSafari وFirefox وEdge.",
    data_security:
      "نعم. أمانك وخصوصيتك أولويتنا الأولى. AskSalah يستخدم تشفير شامل لحماية بياناتك أثناء الجلسات ويتوافق مع اللوائح الدولية لحماية البيانات مثل GDPR وCCPA. لا يتم مشاركة المحادثات مع أطراف ثالثة، ويتم تخزين جميع البيانات بأمان.",
  },
};

// Contextual messages for follow-up questions
export const CONTEXTUAL_MESSAGES = {
  en: {
    "Subscription & Access":
      "Would you like to know more about subscription requirements or access options?",
    Pricing:
      "Do you have any specific questions about our pricing plans or costs?",
    "Usage Rules":
      "Is there anything about session limits or usage policies you'd like to clarify?",
    "How to Use Sessions":
      "Would you like help with starting sessions or managing your account?",
    "Plan Differences":
      "Do you need more details about the differences between our plans?",
    "Technical & General":
      "Is there anything technical or general about AskSalah you'd like to know?",
  },
  ar: {
    "الاشتراك في البرنامج":
      "هل تريد معرفة المزيد حول متطلبات الاشتراك أو خيارات الوصول؟",
    "مبالغ الاشتراك": "هل لديك أسئلة محددة حول خطط التسعير أو التكاليف؟",
    "قواعد الاستخدام":
      "هل هناك شيء حول حدود الجلسات أو سياسات الاستخدام تريد توضيحه؟",
    "كيفية استخدام الجلسة": "هل تريد المساعدة في بدء الجلسات أو إدارة حسابك؟",
    "الاختلاف بين الاشتراكات":
      "هل تحتاج إلى تفاصيل أكثر حول الاختلافات بين خططنا؟",
    "أسئلة تقنية وعامة": "هل هناك شيء تقني أو عام حول AskSalah تريد معرفته؟",
  },
};

// Fallback contextual messages
export const FALLBACK_CONTEXTUAL_MESSAGES = {
  en: "Is there anything specific about {category} that I can help you with?",
  ar: "هل هناك شيء محدد حول {category} يمكنني مساعدتك فيه؟",
};
